const {ccclass, property} = cc._decorator;

@ccclass
export default class ToggleItem extends cc.Component {
    @property(cc.Node)
    nodeMark: cc.Node = null

    @property(cc.Label)
    lbName: cc.Label = null

    @property({type: cc.String})
    set toggleName (value) {
        this.lbName.string = value
    }

    get toggleName () {
        return this.lbName ? this.lbName.string : ""
    }

    @property({type: cc.Boolean, visible: false})
    set isChecked (value) {
        this.nodeMark.active = value
    }

    get isChecked () {
        return this.nodeMark ? this.nodeMark.active : false
    }

    @property(cc.String)
    userData: string = ""

    onLoad () {
        this.isChecked = false
    }
}
